module.exports = __webpack_public_path__ + "static/media/YB5M10_01.46bc8692.jpg";